export const BUTTON_PRIMARY = 'primary'
export const BUTTON_TRANSPARENT = 'transparent'
export const BUTTON_DARK = 'dark'
export const BUTTON_DANGER = 'danger'
